import { ConfigurationsModel } from '@/core/domain/configurations/models/configurations.model';

export const loadReducer = (
    _: ConfigurationsModel,
    { value }: { value: ConfigurationsModel },
): ConfigurationsModel => value;
